import React, { useEffect } from 'react'
import {
  AccountingCharts,
  ChartStatus,
  DateRanges,
  ProfitAndLossReport,
  QueryAccountingReportInput,
} from '../../../../__generated__/api-types-and-hooks'
import { AppAccountingStatValue } from 'components/AppDataReport/AppData/AppAccountingStatValue'
import { ReduxAction } from 'store/types'
import Loader from 'components/Loaders'
import OwnerApi from 'api/ownerData'
import { OperationName } from 'types'
import withChartWrapper, { WithChartWrapperProps } from 'components/AppDataReport/AppData/ChartHOC'
import { useFetchChartData } from 'hooks/useFetchChartData'
import { useSelector } from 'react-redux'
import { ROLES } from 'config'
import { RootState } from 'App'
import { getRoleFromPath } from 'utils/helper'

export interface IAppProfitAndLossChartProps {
  chartData: { data?: ProfitAndLossReport[]; status: ChartStatus }
  isLoading?: boolean
  getDataAction: ReduxAction<QueryAccountingReportInput>
  period?: DateRanges
}

type AppProfitAndLossData = { data?: ProfitAndLossReport[]; status: ChartStatus }

const onFetchDataMethod = async (
  params: QueryAccountingReportInput
): Promise<AppProfitAndLossData | undefined> => {
  const data = await OwnerApi.getOwnerAccountingData<ProfitAndLossReport[]>(params)
  return data?.getAccountingCharts
}

const ACCOUNTING_CHARTS_QUERY_KEY: OperationName = 'getAccountingCharts'

interface IAppProfitAndLossProps
  extends WithChartWrapperProps<QueryAccountingReportInput, AppProfitAndLossData> {
  period: DateRanges
}

export const AppProfitAndLossChart = withChartWrapper(
  onFetchDataMethod,
  ({ onFetchData, chartData, period }: IAppProfitAndLossProps) => {
    const { mutate: fetchData, isLoading } = useFetchChartData(
      onFetchData,
      ACCOUNTING_CHARTS_QUERY_KEY
    )

    const userId =
      getRoleFromPath() === ROLES.BUSINESS_OWNER
        ? useSelector((state: RootState) => state.user.user.id)
        : useSelector((state: RootState) => state.clients.client.profile.id)

    useEffect(() => {
      fetchData({
        chartType: AccountingCharts.ProfitAndLoss,
        dateRange: period,
        userId,
      })
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [period])

    return (
      <div className="flex flex-col font-semibold leading-7 text-lg font-primary p-10">
        <p>P&L</p>
        {isLoading && <Loader loader="TableLoader" />}
        {chartData?.data?.length ? (
          <AppAccountingStatValue
            isLoading={isLoading}
            chartValue={chartData?.data[0]?.profitAndLossNetIncome ?? 0}
            chartGrowthValue={chartData?.data[0]?.growth ?? 0}
            dateRange={chartData?.data[0].dateRange ?? DateRanges.ThisYearToDate}
          />
        ) : (
          <></>
        )}
      </div>
    )
  }
)
